import { Navigate, createBrowserRouter } from 'react-router-dom'
import MainLayout from '../components/Layout'
import Login from '../components/Authentication/Login'
import Register from '../components/Authentication/Register'

import PrivateRoutes from '../Routes/PrivateRoutes'
import UserProfile from '../components/Authentication/UserProfile'
import Pages404 from '../pages/utility/pages-404'
import Pages403 from '../pages/utility/pages-403'
import Logout from '../components/Authentication/Logout'
import PrivacyPolicy from '../components/PrivacyPolicy/PrivacyPolicy'
import ForgetPasswordPage from '../components/Authentication/ForgetPassword'
import Dashboard from '../components/Dashboard'
import OrderDetails from '../components/orders/OrderDetails'
import CreatePassword from '../components/Authentication/CreatePassword'
import ChangePassword from '../components/Authentication/ChangePassword'
import AdminOrders from '../components/orders/AdminOrders'
import MoleculesTable from '../components/Reports/Molecules/MoleculesTable'
import PharmacyProfile from '../components/Authentication/PharmacyProfile'
import PharmaciesTable from '../components/Pharmacies/PharmaciesTable'
import AdminsTable from '../components/Administrators/AdminsTable'
import PharmacyOrders from '../components/orders/PharmacyOrders/PharmacyOrders'
import MoleculesReport from '../components/Reports/MoleculesReport'
import MoleculeHistory from '../components/Reports/Molecules/MoleculeHistory'
import ManufacturersAdmin from '../components/Reports/Manufacturers/ManufacturersAdmin'
import ManufacturersPharmacy from '../components/Reports/Manufacturers/ManufacturersPharmacy'
import AdminUploadFile from '../components/Upload/AdminUploadFile'
import AddOrders from '../components/AddOrders/AddOrders'
import Recommendations from '../components/Recommendations/Recommendations'
import ManufacturersTable from '../components/Reports/Manufacturers/ManufacturersTable'
import ManufacturersUsers from '../components/ManufacturersUsers'
import ManufacturerOrders from '../components/ManufacturerOrders/ManufacturerOrders'
import ManufacturerOrderDetails from '../components/ManufacturerOrders/ManufacturerOrderDetails'
import AdminPrivate from './AdminPrivate'
import ManufacturersPrivate from './ManufacturersPrivate'
import PharmacyPrivate from './PharmacyPrivate'
import LoginManufacturer from '../components/Authentication/LoginManufacturer'
import LoginAdmin from '../components/Authentication/LoginAdmin.js'
import AdsControlPanel from '../components/AdsControlPanel/AdsControlPanel.js'
import Module from './Module'
import StatusAccessControl from './StatusAccessControl.js'
import ManufacturerApproval from '../components/MailActions/ManufacturerApproval.js'
import ManufacturerRejection from '../components/MailActions/ManufacturerRejection.js'
import OrderApproval from '../components/MailActions/OrderApproval.js'
import OrderRejection from '../components/MailActions/OrderRejection.js'
import Responded from '../components/MailActions/Responeded.js'
import ManufacturersReports from '../components/Reports/Manufacturers/ManufacturersReports.js'
import ManufacturerResponse from '../components/MailActions/ManufacturerResoponse.js'
import OrderResponse from '../components/MailActions/OrderResponse.js'
import PaPayables from '../components/Reports/PAPaymentTable/PaPayables.js'
import PaPayablesPharmacies from '../components/Reports/PAPaymentTable/PaPayablesPharmacies.js'
import PaPayablesPharmacyDetail from '../components/Reports/PAPaymentTable/PaPayablesPharmacyDetail.js'
import PharmacyPaPayments from '../components/Reports/PAPaymentTable/PharmacyPaPayments.js'
import PaPaymentsBatches from '../components/Reports/PAPaymentTable/PaPaymentsBatches.js'
import CataloguePage from '../components/Catalogue/CataloguePage.js'
import CatalogueImportWizard from '../components/Catalogue/CatalogueImportWizard.js'
import CatalogueAdminTable from '../components/Catalogue/CatalogueAdminTable.js'
import PharmacyGroupsTable from '../components/PharmacyGroups/PharmacyGroupsTable.js'
import BlockInGroupMode from './BlockInGroupMode.js'
export const router = createBrowserRouter([
  {
    path: '/',
    element: <PrivateRoutes />,
    errorElement: <Pages404 />,
    children: [
      {
        path: '',
        element: <MainLayout />,
        children: [
          { index: true, element: <Dashboard /> },

          {
            path: 'pharmacy',
            element: <PharmacyPrivate />,
            children: [
              {
                index: true,
                element: <Dashboard />,
              },
              {
                path: 'profile',
                element: <StatusAccessControl />,
                children: [{ index: true, element: <UserProfile /> }],
              },
              {
                path: 'manufacturers-reports',

                children: [{ index: true, element: <ManufacturersReports /> }],
              },

              {
                path: 'add-orders',
                element: <StatusAccessControl />,
                children: [
                  {
                    element: <Module />,
                    children: [
                      {
                        index: true,
                        element: <AddOrders />,
                      },
                    ],
                  },
                ],
              },
              {
                path: 'orders',
                element: <StatusAccessControl />,
                children: [
                  { index: true, element: <PharmacyOrders /> },
                  { path: ':orderId', element: <OrderDetails /> },
                ],
              },
              {
                path: 'manufacturers',
                element: <StatusAccessControl />,
                children: [{ index: true, element: <ManufacturersPharmacy /> }],
              },
              {
                path: 'recommendations',
                element: <StatusAccessControl />,
                children: [
                  {
                    index: true,
                    element: <Recommendations />,
                  },
                ],
              },
              {
                path: 'pa-payments',
                element: <PharmacyPaPayments />,
              },
            ],
          },

          {
            path: 'admin',
            element: <AdminPrivate />,
            children: [
              {
                index: true,
                element: <Dashboard />,
              },
              {
                path: 'profile',
                element: <UserProfile />,
                children: [{ index: true, element: <UserProfile /> }],
              },
              {
                path: 'pharmacies',
                element: <PharmaciesTable />,
              },
              {
                path: 'reports/manufacturers',
                element: <ManufacturersAdmin />,
              },
              {
                path: 'reports/paPayments',
                element: <PaPaymentsBatches />,
              },
              {
                path: 'reports/paPayables',
                element: <PaPayablesPharmacies />,
              },
              {
                path: 'reports/paPayables/pharmacy/:pharmacyId',
                element: <PaPayablesPharmacyDetail />,
              },
              {
                path: 'reports/paPayables/orders',
                element: <PaPayables />,
              },
              {
                path: 'pharmacies/:pharmacyId',
                element: <PharmacyProfile />,
              },
              {
                path: 'admins-list',
                element: <AdminsTable />,
              },

              {
                path: 'orders',
                element: <AdminOrders />,
              },
              {
                path: 'orders/:orderId',
                element: <OrderDetails />,
              },
              {
                path: 'molecules',
                element: <MoleculesTable />,
              },
              {
                path: 'manufacturers',
                element: <ManufacturersTable />,
              },
              {
                path: 'manufacturers-users',
                element: <ManufacturersUsers />,
              },
              {
                path: 'ads-control-panel',
                element: <AdsControlPanel />,
              },
              {
                path: 'pharmacy-groups',
                element: <PharmacyGroupsTable />,
              },
              {
                path: 'upload-file',
                element: <AdminUploadFile />,
              },

              {
                path: 'reports',
                children: [
                  // {
                  //   index: true,
                  //   element: <GenerateReport />,
                  // },

                  {
                    path: 'molecules',
                    element: <MoleculesReport />,
                  },
                  {
                    path: 'molecules/:din',
                    element: <MoleculeHistory />,
                  },
                ],
              },
              {
                path: 'recommendations',
                element: <Recommendations />,
              },
              {
                path: 'catalogue',
                element: <Navigate to='import' replace />,
              },
              {
                path: 'catalogue/import',
                element: <CatalogueImportWizard />,
              },
              {
                path: 'catalogue/manage',
                element: <CatalogueAdminTable />,
              },
            ],
          },

          {
            path: 'manufacturer',
            element: <ManufacturersPrivate />,
            children: [
              {
                index: true,
                element: <Dashboard />,
              },
              {
                path: 'profile',
                element: <UserProfile />,
              },
              { path: 'manufacturerOrders', element: <ManufacturerOrders /> },
              {
                path: 'manufacturerOrders/:orderId',
                element: <ManufacturerOrderDetails />,
              },
              {
                path: 'catalogue',
                element: <Navigate to='import' replace />,
              },
              {
                path: 'catalogue/import',
                element: <CatalogueImportWizard />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/manufacturer-login',
    element: (
      <BlockInGroupMode>
        <LoginManufacturer />
      </BlockInGroupMode>
    ),
  },
  {
    path: '/admin-login',
    element: (
      <BlockInGroupMode>
        <LoginAdmin />
      </BlockInGroupMode>
    ),
  },
  {
    path: '/register',
    element: (
      <BlockInGroupMode>
        <Register />
      </BlockInGroupMode>
    ),
  },
  {
    path: '/create-password',
    element: <CreatePassword />,
  },
  {
    path: '/forget-password',
    element: <ForgetPasswordPage />,
  },
  {
    path: '/403',
    element: <Pages403 />,
  },
  {
    path: '/change-password',
    element: <ChangePassword />,
  },
  {
    path: '/logout',
    element: <Logout />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: 'pharmacy-account-response/:token',
    element: <ManufacturerResponse />,
  },
  {
    path: 'pharmacy-account-approved',
    element: <ManufacturerApproval />,
  },
  {
    path: 'pharmacy-account-rejected',
    element: <ManufacturerRejection />,
  },
  {
    path: 'pharmacy-order-approved',
    element: <OrderApproval />,
  },
  {
    path: 'pharmacy-order-rejected',
    element: <OrderRejection />,
  },
  {
    path: 'order-response/:orderId',
    element: <OrderResponse />,
  },
  {
    path: 'already-responded',
    element: <Responded />,
  },
])
